<template>
    <div class="row">
        <div class="col">
            <div class="row">
                <div :class="['col', 'selector-header', {'open-dropdown' : showPrices}]"  @click="toggleCosts">
                    <h3>Fuel prices</h3>
                </div>
            </div>
            <b-collapse class="row" id="fuel-prices" v-model="showPrices">
                <div class="col">
                    <div class="form">
                        <div class="row row__fuel_prices">
                            <div class="col-sm col-md-6">
                                <label for="elPrice">Electric cost per kWh</label>
                                <div class="pretty-input input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="electric-pound">£</span>
                                    </div>
                                    <input :value="electric" @complete="onElectricComplete"
                                           v-imask="priceMask" type="text"  id="elPrice"
                                           aria-describedby="electric-pound" class="form-control"/>
                                </div>
                                <span class="error" v-if="electricError">{{electricError}}</span>
                            </div>
                            <div class="col-sm col-md-6">
                                <div v-if="fuelType === 'petrol'">
                                    <label for="petPrice">Petrol cost per litre</label>
                                    <div class="pretty-input input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="petrol-pound">£</span>
                                        </div>
                                        <input :value="petrol" @complete="onPetrolComplete"
                                               v-imask="priceMask" type="text" id="petPrice"
                                               aria-describedby="petrol-pound" class="form-control"/>
                                    </div>
                                    <span class="error" v-if="petrolError">{{petrolError}}</span>
                                </div>
                                <div v-else>
                                    <div id="diesel">
                                        <label for="diePrice">Diesel cost per litre</label>
                                        <div class="pretty-input input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="diesel-pound">£</span>
                                            </div>
                                            <input :value="diesel" @complete="onDieselComplete"
                                                   v-imask="priceMask" type="text" id="diePrice"
                                                   aria-describedby="diesel-pound" class="form-control"/>
                                        </div>
                                        <span class="error" v-if="dieselError">{{dieselError}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
        </div>
    </div>
</template>

<script>
    import { BCollapse } from 'bootstrap-vue'
    import { ELECTRIC_VALID, PETROL_VALID, DIESEL_VALID } from "../store/action-types";
    import { IMaskDirective } from 'vue-imask'
    export default {
        name: "FuelPrices",
        components:{
            BCollapse,
        },
        data(){
            return{
                showPrices: false,
                currencyConfig: {
                    decimal: '.',
                    thousands: ',',
                    prefix: '£',
                    precision: 4,
                    masked: false
                },
                priceMask: {
                    mask: Number,
                    scale: 4,
                    signed: false,
                    thousandsSeparator: ',',
                    padFractionalZeros: false,
                    normalizeZeros: false,
                    radix: '.',
                    mapToRadix: ['.'],
                },
            }
        },
        computed: {
            fuelType: function() {
                return this.$store.state.FUEL_TYPE
            },
            petrol: function(){
                return this.$store.state.FUEL_PRICE_PETROL;
            },
            diesel: function(){
                return this.$store.state.FUEL_PRICE_DIESEL;
            },
            electric: function(){
                return this.$store.state.FUEL_PRICE_ELECTRIC;
            },
            petrolError: function() {
                if (this.$store.state.ERRORS.petrol) {
                    return this.$store.state.ERRORS.petrol;
                }
                return false;
            },
            dieselError: function() {
                if (this.$store.state.ERRORS.diesel) {
                    return this.$store.state.ERRORS.diesel;
                }
                return false;
            },
            electricError: function() {
                if (this.$store.state.ERRORS.electric) {
                    return this.$store.state.ERRORS.electric;
                }
                return false;
            }
        },
        methods:{
            toggleCosts: function() {
                this.showPrices = !this.showPrices;
            },
            onElectricComplete: function(e) {
                this.$store.dispatch(ELECTRIC_VALID, e.detail.unmaskedValue);
            },
            onPetrolComplete: function (e) {
                this.$store.dispatch(PETROL_VALID, e.detail.unmaskedValue);
            },
            onDieselComplete: function (e) {
                this.$store.dispatch(DIESEL_VALID, e.detail.unmaskedValue);
            }
        },
        directives: {
            imask: IMaskDirective
        }
    }
</script>

<style scoped lang="stylus">
    .selector-header
        cursor pointer
        h3
            margin-top 0
        &:after
            content ''
            position absolute
            z-index 10
            right 16px
            top 0
            height 100%
            width 40px
            background-image url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='9' viewBox='0 0 15 9'%3E%3Cpath fill='%23004666' fill-rule='nonzero' d='M1.588.03l5.883 5.882L13.41-.03l1.56 1.558-7.5 7.5L.029 1.59 1.59.028z'/%3E%3C/svg%3E")
            background-repeat no-repeat
            background-position 50% 50%
            pointer-events none
            cursor pointer
            border-left none

        &.open-dropdown
            &:after
               transform scaleY(-1)
        h3
            margin-bottom 0
    .form
        margin-right 0
        flex-direction column
        flex-wrap: nowrap
        margin-top 2.5rem
        .row
            &__fuel_prices
                margin-bottom 0.5rem
        .pretty-input
            border solid 1px $color-grey-border

            input
                text-align right
                padding-right 1rem
                height 42px
                border none
                font-family $font-regular
                color $color-font
                font-size 1.8rem

            .input-group-text
                width 4.2rem
                justify-content center
                height 42px
                border none
                font-family $font-regular
                color $color-font
                font-size 1.8rem
                background-color #f2f2f2

        .error
            margin-top 0.8rem
            color $color-red
            font-size 1.3rem
</style>